import { useSyncExternalStore } from "react";
import { getTheme, onThemeChange } from "../../themeState";

// themeState.ts keeps sole ownership of writing localStorage/data-theme for
// the whole migration - this hook only ever reads and subscribes. Imports
// themeState.ts, not theme.ts, deliberately - theme.ts pulls in dom.ts's
// entire side-effecting module graph via themeToggleBtn.
export function useColorScheme(): "light" | "dark" {
  return useSyncExternalStore(onThemeChange, getTheme);
}
